import * as angular from 'angular';
import { ComponentDefinition } from '../../models';
import { ExcludedDates } from '../../services';

class ExcludedDatesController implements angular.IComponentController {
    readonly excludedDates: ExcludedDates[];
    static $inject = [];
}

export const wtExcludedDates: ComponentDefinition = {
    componentId: 'wtExcludedDates',
    controller: ExcludedDatesController,
    template: require('./excludedDates.component.html'),
    controllerAs: 'vm',
    bindings: {
        excludedDates: '<'
    }
};
